import {
  requestGet as wsRequestGet,
  requestPost as wsRequestPost
} from "./_wsApiFetchData";

export async function searchParticipant(options, language, timeZone, cancelToken) {
  const { skipPages, resultsCount, filters } = options;
  const {
    type,
    status,
    purchaseId,
    providerId,
    userId,
    facilityId,
    purchaseProductId,
    participantId,
    afterAt,
    beforeAt,
    billingAfterAt,
    billingBeforeAt,
    occursAfterAt,
    occursBeforeAt,
    orderBy,
    orderDirection
  } = filters;

  const params = {
    Page: skipPages || 1,
    Count: resultsCount,
    Id: participantId,
    type,
    status,
    purchaseId,
    providerId,
    userId,
    facilityId,
    afterAt,
    beforeAt,
    billingAfterAt,
    billingBeforeAt,
    occursAfterAt,
    occursBeforeAt,
    purchaseProductId,
    // Both optional. Absent, the endpoint answers what it always has — newest
    // first by creation — so the old admin's request is unchanged.
    OrderBy: orderBy || undefined,
    OrderDirection: orderDirection || undefined
  };

  return toPascal(await wsRequestGet('/admin/participants/search', language, timeZone, params, cancelToken));
}

export async function getParticipant(id, language, timeZone, cancelToken) {
  return toPascal(await wsRequestGet(`/admin/participants/get/${id}`, language, timeZone, null, cancelToken));
}

export async function addParticipant(
  {
    UserId,
    PurchaseProductId
  },
  language,
  timeZone,
  cancelToken
) {
  return toPascal(await wsRequestPost('/admin/participants/add', language, timeZone, {
    UserId,
    PurchaseProductId
  },
  null,
  cancelToken));
}

function toPascal(o) {
  var newO, origKey, newKey, value
  if (o instanceof Array) {
    return o.map(function(value) {
        if (typeof value === "object") {
          value = toPascal(value)
        }
        return value
    })
  } else {
    newO = {}
    for (origKey in o) {
      if (o.hasOwnProperty(origKey)) {
        newKey = (origKey.charAt(0).toUpperCase() + origKey.slice(1) || origKey).toString()
        value = o[origKey]
        if (value instanceof Array || (value !== null && value.constructor === Object)) {
          value = toPascal(value)
        }
        newO[newKey] = value
      }
    }
  }
  return newO
}
